import * as swcHelpers from '@swc/helpers';
import { combineReducers } from 'redux';
import { CLEAR_ERROR, UPDATE_CART_STATE, ORDER_CREATE_FAILED, ORDER_GET_BY_TOKEN_SUCCESS, ORDER_CREATE_SUCCESS, INIT, ORDER_CLEAR, ORDER_SET, INIT_ORDER, ORDER_GET_BY_TOKEN_FAILED, CART_UPDATE_FAILED, SET_CHANGED_OPT_INS, ACCOUNT_CREATE_SUCCESS, TOGGLE_ACCOUNT_CREATION, GET_ADDITIONAL_COSTS_SUCCESS } from './actions.js';
import { addressBookReducer } from './AddressBook/reducer.js';
import { CheckoutState } from './state.js';
import paymentReducer from './StepPayment/reducer.js';
import shippingMethodsReducer from './StepShipping/modules/ShippingMethods/state/reducer.js';
import shippingReducer from './StepShipping/reducer.js';
import { CartState } from './models/cart/cart-state.js';

const initialRootState = {
    state: CheckoutState.Uninitialized
};
/**
 * Main checkout reducer - handles actions that are not related to a specific step of the checkout
 */ function checkoutReducer(state = initialRootState, action) {
    switch(action.type){
        case INIT:
            return {
                state: CheckoutState.Initialized,
                cartState: CartState.InProgress
            };
        case ORDER_CREATE_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Completed
            });
        case ORDER_GET_BY_TOKEN_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Callback
            });
        case ORDER_CREATE_FAILED:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Failed
            });
        case UPDATE_CART_STATE:
            return swcHelpers.objectSpread({}, state, action.payload);
        case CLEAR_ERROR:
            return swcHelpers.objectSpread({}, state, {
                state: CheckoutState.Initialized
            });
        default:
            return state;
    }
}
function orderReducer(state = null, action) {
    switch(action.type){
        case INIT_ORDER:
            return null;
        case ORDER_SET:
        case ORDER_CREATE_SUCCESS:
            return swcHelpers.objectSpread({}, state, action.payload.order);
        case ORDER_CLEAR:
            return null;
        case ORDER_GET_BY_TOKEN_SUCCESS:
            return swcHelpers.objectSpread({}, state, {
                order: action.payload.order
            });
        default:
            return state;
    }
}
function errorReducer(state = null, action) {
    switch(action.type){
        case CART_UPDATE_FAILED:
        case ORDER_CREATE_FAILED:
        case ORDER_GET_BY_TOKEN_FAILED:
            return swcHelpers.objectSpread({}, state, action.error);
        case CLEAR_ERROR:
            return null;
        default:
            return state;
    }
}
function myAccountReducer(state = null, action) {
    switch(action.type){
        case TOGGLE_ACCOUNT_CREATION:
            const { shouldCreateAccount  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                shouldCreateAccount
            });
        case ACCOUNT_CREATE_SUCCESS:
            const { id  } = action.payload;
            return swcHelpers.objectSpread({}, state, {
                newUserId: id
            });
        case SET_CHANGED_OPT_INS:
            return swcHelpers.objectSpread({}, state, {
                changedOptIns: action.payload
            });
        default:
            return state;
    }
}
function additionalCostsReducer(state = [], action) {
    switch(action.type){
        case GET_ADDITIONAL_COSTS_SUCCESS:
            return [
                ...action.payload.result
            ];
        default:
            return state;
    }
}
/**
 * Root checkout reducer - returns complete checkout state
 */ var reducer = combineReducers({
    root: checkoutReducer,
    shippingMethods: shippingMethodsReducer,
    shipping: shippingReducer,
    payment: paymentReducer,
    order: orderReducer,
    error: errorReducer,
    myAccount: myAccountReducer,
    additionalCosts: additionalCostsReducer,
    addressBook: addressBookReducer
});

export { additionalCostsReducer, checkoutReducer, reducer as default, errorReducer, initialRootState, myAccountReducer, orderReducer };
//# sourceMappingURL=reducer.js.map
